/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import styles from './styles';

const pdf_src = process.env.REACT_APP_PDF_URL;

const PdfServices = ({ t, classes }) => {
  const { container, separation, section_pdf } = classes;
  return (
    <div className={container}>
      <h3 className={separation}>{t('screens.PDF.title')}</h3>
      <p className={separation}>{t('screens.PDF.description')}</p>
      <iframe title="Sample PDF" src={pdf_src} className={section_pdf}  frameBorder="0"></iframe>
    </div>
  );
};

PdfServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(PdfServices));
